import {
  SearchableVendorTaxonomyKey,
  VENUES_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace';

import { createSelector } from 'reselect';

import { RootState } from '~/reducers';

export const getMiniQuizTaxonomyKey = (state: RootState) =>
  state.couples.miniQuiz.activeTaxonomyKey;

export const getMiniQuizForTaxonomy = (taxonomyKey: SearchableVendorTaxonomyKey) =>
  createSelector(
    (state: RootState) => state.couples.miniQuiz,
    (miniQuizState) => {
      const { loaded, values } = miniQuizState[taxonomyKey || VENUES_TAXONOMY_KEY];
      return { loaded, values };
    }
  );
